import React, { useState, useEffect } from "react";
import { Box, Grid, Button, TextField, Divider } from "@mui/material";
import { H4, Small, H5, H6 } from "components/Typography";
import OTPModel from "components/OTPModel";
import SIPdateModel from "components/SIPdateModel";
import aesEncrypt from "../../constants/aesEncrypt";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import DashboardNavbar from "components/DashboardNavbar";
import { load, remove } from "../../constants/storage";
import { useAppDispatch } from "../../store/hooks";
import * as Models from "../../models";
import { toast } from "react-hot-toast";
import { useNavigate, useLocation } from "react-router-dom";
import {
  getFundisin,
  orderMutualFund,
  orderLumpsumMutualFund,
  otpGenerateForMutualFund,
  otpVerifyForMutualFund,
  createSIPMandate
} from "redux/actions/PortfolioAction";
import { API_BASE_URL } from "Api/EndPoints";

export default function NFOFundDetails() {
  const dispatch = useAppDispatch();
  let navigate = useNavigate();
  let routeData = useLocation();
  const { data } = routeData.state;
  const [selected, setSelected] = useState(1);
  const [metalType, setMetalType] = useState("Onetime");
  const [fundType, setFundType] = useState("ExitLoad");

  const [loading, setLoading] = useState(true);
  const [ISIN, setISIN] = useState("");
  //fund sip
  const [fundDetails, setFundDetails] = useState<string>("");
  const [investedAmount, setInvestedAmount] = useState<string>("");
  const [investedSipAmount, setInvestedSipAmount] = useState<string>("");
  const [minSipAmount, setMinSipAmount] = useState<string>("");
  const [maxSipAmount, setMaxSipAmount] = useState<string>("");

  //One Time
  const [buyInvestedAmount, setBuyInvestedAmount] = useState<string>("");
  const [buyMinAmount, setBuyMinAmount] = useState<string>("");
  const [buyMaxAmount, setBuyMaxAmount] = useState<string>("");
  // One Time Button
  const [firstTouchableOpacity, setFirstTouchableOpacity] = useState(true);
  const [secondTouchableOpacity, setSecondTouchableOpacity] = useState(false);
  const [thirdTouchableOpacity, setThirdTouchableOpacity] = useState(false);
  const [fourthTouchableOpacity, setFourthTouchableOpacity] = useState(false);
  const [firstValue, setFirstValue] = useState("");
  const [secondValue, setSecondValue] = useState("");
  const [thirdValue, setThirdValue] = useState("");

  // Sip Button
  const [selectedDate, setSelectedDate] = useState("");
  const [sipDateList, setDateList] = useState();
  const [sipLastDate, setSipLastDate] = useState();

  const [paymentValue, setPaymentValue] = useState("upi");
  //otp model
  const [openModal, setOpenModal] = useState(false);
  const [requestID, setRequestID] = React.useState("");
  const [virtualAccID, setVirtualAccID] = useState("");

  //sip model
  const [sipdateModel, setSipDateModel] = useState(false);

  const handlesipOpenModal = () => {
    setSipDateModel(true);
  };
  const handlesipCloseModal = () => {
    setSipDateModel(false);
  };

  const handleOpenModal = () => {
    setOpenModal(true);
  };
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  useEffect(() => {
    checkToken();
  }, [metalType]);

  const checkToken = async () => {
    let token = await load("token");
    if (token === undefined) {
      remove("userData");
      remove("token");
      toast.success("Session expired, please login again.");
      navigate("/login");
    } else {
      getFundSipDetail();
    }
  };

  const handleChangePaymentrValue = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setPaymentValue((event.target as HTMLInputElement).value);
  };

  const dots = () => {
    return <Grid sx={sxStyleDotStyle} />;
  };

  const getFundSipDetail = async () => {
    setLoading(true);
    let token = load("token");
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);
    const req: Models.MutualFundsDetailRequest = {
      id: userDetails.id,
      mobile: userDetails.mobile,
      partner: userDetails?.refcode,
      isin: data.isin,
    };

    dispatch(getFundisin(req, `bearer ${token}`))
      .then(async (response: any) => {
        setLoading(false);

        if (response.statusCode === 400) {
          return;
        }
        setISIN(response?.holdings?.isin ?? "");
        setFundDetails(response?.holdings ?? "");
        //sip
        setMinSipAmount(
          response?.holdings?.sip_frequency_specific_data?.monthly
            ?.min_installment_amount
        );
        setMaxSipAmount(
          response?.holdings?.sip_frequency_specific_data?.monthly
            ?.max_installment_amount
        );
        setInvestedSipAmount(
          response?.holdings?.sip_frequency_specific_data?.monthly
            ?.min_installment_amount
        );

        //Buy fund
        setInvestedAmount(response?.holdings.min_initial_investment ?? "");
        setBuyInvestedAmount(response?.holdings.min_initial_investment ?? "");
        setBuyMinAmount(response?.holdings?.min_initial_investment ?? "");
        setBuyMaxAmount(response?.holdings?.max_initial_investment ?? "");
        if (response?.holdings?.sip_frequency_data) {
          const dateListString =
            response?.holdings?.sip_frequency_data["MONTHLY"];
          const dateList = dateListString.split(",");
          setDateList(dateList);
          setSipLastDate(
            dateList?.length > 0 ? dateList[dateList?.length - 1] : ""
          );
        }
        setFirstValue("2");
        setSecondValue("5");
        setThirdValue("10");
      })
      .catch((error: any) => {
        toast.error(error);
        setLoading(false);
      });
  };

  const dateOrdinal = (d: any) => {
    return (
      d +
      (31 == d || 21 == d || 1 == d
        ? "st"
        : 22 == d || 2 == d
        ? "nd"
        : 23 == d || 3 == d
        ? "rd"
        : "th")
    );
  };

  //OneTme Edit
  const oneTimeChangeHandler: React.ChangeEventHandler<
    HTMLInputElement | HTMLTextAreaElement
  > = (event: any) => {
    const value = event.target.value;
    setInvestedAmount(value);
  };
  const cleanString = (inputString: any) => {
    return inputString?.replace(/[^\x20-\x7E]/g, "");
  };

  // MF Next Buy
  const onNextBuyClick = async () => {
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);
    if (userDetails?.user_status != "ACTIVE") {
      toast.error("Please complete your KYC");
      return;
    }
    if (investedAmount === "") {
      toast.error("Please enter amount");
      return;
    }
    if (investedAmount < buyInvestedAmount) {
      toast.error(`Minimum investment amount is ₹${buyInvestedAmount}`);
      return;
    }
    if (investedAmount > buyMaxAmount) {
      toast.error(`Maximum investment amount is ₹${buyMaxAmount}`);
      return;
    }

    if (userDetails?.user_status === "KYCREJECTED") {
      toast.error("Redo KYC");
      return;
    }

    //MF BUY
    const req = {
      id: userDetails.id,
      mobile: userDetails.mobile,
      partner: userDetails?.refcode,
      purpose: "direct_purchase",
      fund_name: data?.scheme_name ?? "",
      amount: investedAmount,
    };
    await generateOTP(req);
  };

  //OTP
  const generateOTP = (req: any) => {
    setLoading(true);
    let token = load("token");

    dispatch(otpGenerateForMutualFund(req, `bearer ${token}`))
      .then(async (response: any) => {
        setLoading(false);
        if (response?.type === "success") {
          toast.success(response.message);
          handleOpenModal();
          setRequestID(response.request_id);
        }
      })
      .catch((error: any) => {
        setLoading(false);
        toast.error(error);
      });
  };

  // MF SIP
  const onNextSIPClick = async () => {
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);

    if (data.sip_allowed === "N") {
      toast.error("SIP is not available for this fund");
      return;
    }
    if (userDetails?.user_status != "ACTIVE") {
      toast.error("Please complete your KYC");
      return;
    }
    if (!selectedDate) {
      toast.error(`Please select SIP date`);
      return;
    }
    if (investedSipAmount < minSipAmount) {
      toast.error(`Minimum SIP amount is ₹${minSipAmount}`);
      return;
    }
    if (investedSipAmount > maxSipAmount) {
      toast.error(`SIP amount is cannot be greater than ₹${maxSipAmount}`);
      return;
    }

    //SIP
    const req = {
      id: userDetails.id,
      mobile: userDetails.mobile,
      partner: userDetails?.refcode,
      purpose: "purchase_mutual_fund",
      fund_name: data?.scheme_name ?? "",
      amount: investedSipAmount,
    };
    await generateOTP(req);
  };

  //verify OTP OneTime
  const handleSave = async (value: any) => {
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);
    let token = load("token");

    const req = {
      mobile: userDetails.mobile,
      partner: userDetails?.refcode,
      request_id: requestID,
      otp: aesEncrypt(value),
    };

    dispatch(otpVerifyForMutualFund(req, `bearer ${token}`))
      .then(async (response: any) => {
        if (response.message === "OTP Authenticated Successfuly") {
          handleCloseModal();
          if (metalType === "Onetime") {
            await createOrder();
          } else {
            await createSIP();
          }
        } else {
          toast.error(response.message);
        }
      })
      .catch((error: any) => {
        toast.error(error);
      });
  };

  // SIP Edit
  const sipChangeHandler: React.ChangeEventHandler<
    HTMLInputElement | HTMLTextAreaElement
  > = (event: any) => {
    const value = event.target.value;
    setInvestedSipAmount(value);
  };

  const createOrder = async () => {
    setLoading(true);
    let token = await load("token");
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);
    const req: Models.MutualLumpSumFundCreateOrderRequest = {
      userId:  userDetails.id,
      mobileNo: userDetails.mobile,
      userName: `${userDetails?.firstname} ${userDetails?.lastname}`,
      schemeId: data?.isin,
      schemeName: data?.scheme_name,
      folioNumber: "",
      investmentType:  "PURCHASE",
      amount: Number(investedAmount),
      callBackUrl: process.env.REACT_APP_MF_BUY_CALL_BACK_URL || "",
    }
    // const req: Models.MutualFundCreateOrderRequest = {
    //   id: userDetails.id,
    //   mobile: userDetails.mobile,
    //   partner: userDetails?.refcode,
    //   source: "DIRECT",
    //   callbackUrl: process.env.REACT_APP_MF_BUY_CALL_BACK_URL || "",
    //   purchase_type: "PURCHASE",
    //   source_id: 0,
    //   payment_mode: paymentValue,
    //   orders: [
    //     {
    //       amc_code: data?.amc_code ?? "",
    //       isin: data?.isin,
    //       amount: investedAmount,
    //       folio_number: null,
    //       user_ip: "192.168.2.92",
    //       server_ip: "192.168.2.95",
    //     },
    //   ],
    // };

    dispatch(orderLumpsumMutualFund(req, `${token}`))
      .then(async (response: any) => {
        setLoading(false);
        if (response.statusCode === 400) {
          toast?.error(response?.message);
          return;
        }
        // if (response.statusCode == 500) {
        //   toast?.error(response?.message);
        //   return;
        // }
        window.open(response?.data?.token_url, "_self");
      })
      .catch((error: any) => {
        toast.error(error);
        setLoading(false);
      });
  };

  const createSIP = async () => {
    setLoading(true);
    let token = await load("token");
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);

    const consent: Models.ConsentRequest = {
      email: userDetails.email ?? "",
      isd_code: "91",
      mobile: userDetails?.mobile ?? "",
    };
    const req = {
      userId: userDetails.id,
      bankAccId: userDetails.bank_acc_id,
      amount: investedSipAmount,
      scheme: ISIN,
      installmentDay: selectedDate,
      mfInvestmentAccount: userDetails.mfia_id,
      consent: consent,
      virtualAccountId: virtualAccID,
    };

    dispatch(createSIPMandate(req, `${token}`))
      .then(async (response: any) => {
        setLoading(false);

        if (response.statusCode === 400) {
          toast.error(
            response?.error?.message ??
              "Got error while getting a fund details, please try after sometimes!"
          );
          return;
        }
        if (response.statusCode === 500) {
          toast.error(
            "Got error while getting a fund details, please try after sometimes!"
          );
          return;
        }
        if (response.statusCode === 200) {
          window.open(response.data.token_url, "_self");
        } else {
          toast.error(response?.error);
        }
      })
      .catch((error: any) => {
        setLoading(false);
        toast.error(
          "Got error while getting a fund details, please try after sometimes!"
        );
      });
  };

  const handleSaveSipDateModel = (value: any) => {
    setSelectedDate(value);
    handlesipCloseModal();
  };

  const getImgUrl = (pic: string) => {
    if (pic) {
      return API_BASE_URL + pic;
    }
    return "";
  };

  const handleUrlClick = (url: string) => {
    window.open(url, "_blank");
  };

  return (
    <>
      <DashboardNavbar />
      <Grid sx={sxStylebutton}>
        <OTPModel
          open={openModal}
          handleClose={handleCloseModal}
          handleSave={handleSave}
        />
        <SIPdateModel
          open={sipdateModel}
          handleClose={handlesipCloseModal}
          handleSave={handleSaveSipDateModel}
          sipList={sipDateList || []} // add a default empty array if sipDateList is undefined
        />
        <>
          <Grid container>
            <Box
              sx={{
                display: { sm: "none", md: "none", xs: "flex" },
                pb: 1,
                pl: 1,
                pr: 1,
                mt: 3,
                borderRadius: 1,
              }}
            >
              <Box
                component="img"
                src={
                  getImgUrl(`funds/${data?.amc_code}` + ".png")
                    ? getImgUrl(`funds/${data?.amc_code}` + ".png")
                    : "https://acru-asset.s3.us-east-1.amazonaws.com/assets/mf.svg"
                }
                sx={sxStyleImage}
              />
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                  marginLeft: 1.5,
                }}
              >
                <H4 fontSize={14} fontWeight={500} color="#000000" sx={text}>
                  {data?.scheme_name}
                </H4>

                <Grid
                  alignItems="center"
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    mt: 0.5,
                  }}
                >
                  <H6
                    color="#747474"
                    fontWeight={"400"}
                    sx={{ mr: 1, display: "flex" }}
                  >
                    {dots()}
                    {data?.asset_category}
                  </H6>
                  <H6
                    color="#747474"
                    fontWeight={"400"}
                    sx={{ mr: 1, display: "flex" }}
                  >
                    {dots()}
                    {data?.asset_sub_category}
                  </H6>
                  <H6
                    color="#747474"
                    fontWeight={"400"}
                    sx={{ mr: 1, display: "flex" }}
                  >
                    {dots()}
                    {data?.option_name}
                  </H6>
                </Grid>
              </Box>
            </Box>
            <Grid
              xs={12}
              md={6}
              sx={{
                padding: {
                  md: 3,
                  xs: 0,
                  sm: 0,
                },
                pr: 2,
                mt: 1,
              }}
            >
              <Grid
                sx={{
                  background: "#fff",
                  borderRadius: 5,
                  paddingX: {
                    md: 2,
                    xs: 1,
                  },
                  paddingY: {
                    md: 2,
                    xs: 1.5,
                  },
                }}
              >
                <Box
                  sx={{
                    display: { sm: "flex", md: "flex", xs: "none" },
                    pb: 1,
                    pl: 1,
                    pr: 1,
                    borderRadius: 1,
                  }}
                >
                  <Box
                    component="img"
                    src={
                      getImgUrl(`funds/${data?.amc_code}` + ".png")
                        ? getImgUrl(`funds/${data?.amc_code}` + ".png")
                        : "https://acru-asset.s3.us-east-1.amazonaws.com/assets/mf.svg"
                    }
                    sx={sxStyleImage}
                  />
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "column",
                      marginLeft: 1.5,
                    }}
                  >
                    <H4
                      fontSize={14}
                      fontWeight={500}
                      color="#000000"
                      sx={text}
                    >
                      {data?.scheme_name}
                    </H4>

                    <Grid alignItems="center" sx={{ display: "flex" }}>
                      {dots()}
                      <H5 color="#747474" fontWeight={"400"} sx={{ mr: 1 }}>
                        {data?.asset_category}
                      </H5>
                      {dots()}
                      <H5 color="#747474" fontWeight={"400"} sx={{ mr: 1 }}>
                        {data?.asset_sub_category}
                      </H5>
                      {dots()}
                      <H5 color="#747474" fontWeight={"400"}>
                        {data?.option_name}
                      </H5>
                    </Grid>
                  </Box>
                </Box>
                <Box
                  sx={{
                    borderRadius: 4,
                    ml: { xs: 1, sm: 1, md: 2 },
                    mr: { xs: 1, sm: 1, md: 2 },
                    mb: { xs: 1, sm: 1, md: 1 },
                    mt: { xs: 1, sm: 1, md: 1 },
                    boxShadow: {
                      xs: 0,
                      sm: "0px 4px 10px rgba(239, 239, 239, 1)",
                      md: "0px 4px 10px rgba(239, 239, 239, 1)",
                    },
                  }}
                >
                  {/* NAV/Rating */}
                  <Grid
                    sx={{
                      display: "flex",
                      borderTopLeftRadius: 10,
                      borderTopRightRadius: 10,
                    }}
                  >
                    <Grid
                      sx={{
                        width: "50%",
                        alignItems: "center",
                        justifyContent: "center",
                        display: "flex",
                        flexDirection: "column",
                        borderTopColor: "#EFEFEF",
                        borderTopWidth: 0.2,
                        mt: 0.5,
                        mb: 0.5,
                      }}
                    >
                      <H4
                        color="#000"
                        fontSize={14}
                        sx={{
                          width: "100%",
                          textAlign: "center",
                        }}
                        fontWeight={"600"}
                      >
                        10.00
                      </H4>
                      <H5
                        sx={{
                          fontFamily: "'Poppins', sans-serif",
                          textAlign: "center",
                        }}
                        fontSize={12}
                        color={"#868686"}
                        fontWeight={"400"}
                      >
                        NAV
                      </H5>
                    </Grid>
                    <Grid
                      sx={{
                        width: "50%",
                        alignItems: "center",
                        justifyContent: "center",
                        display: "flex",
                        flexDirection: "column",

                        borderLeftWidth: "1px", // set the left border width to 2 pixels
                        borderLeftStyle: "solid", // set the left border style to solid
                        borderLeftColor: "#EFEFEF", // set the left border color

                        pt: 0.5,
                        pb: 0.5,
                      }}
                    >
                      <Grid
                        justifyContent="center"
                        alignItems="center"
                        sx={{ display: "flex" }}
                      >
                        <H4
                          color="#000"
                          fontSize={14}
                          sx={{
                            width: "100%",
                            textAlign: "center",
                          }}
                          fontWeight={"600"}
                        >
                          {data.launch_date}
                        </H4>
                      </Grid>
                      <H5
                        sx={{
                          fontFamily: "'Poppins', sans-serif",
                          textAlign: "center",
                        }}
                        fontSize={12}
                        color={"#868686"}
                        fontWeight={"400"}
                      >
                        Open Date
                      </H5>
                    </Grid>
                  </Grid>
                  {/* Investment /Size */}
                  <Divider sx={{ color: "#EFEFEF" }} />
                  <Grid
                    sx={{
                      display: "flex",
                      borderColor: "#EFEFEF",
                      borderBottomLeftRadius: 15,
                      borderTopColor: "#EFEFEF",
                      borderTopWidth: 1,
                      borderBottomRightRadius: 15,
                    }}
                  >
                    <Grid
                      sx={{
                        width: "50%",
                        alignItems: "center",
                        justifyContent: "center",
                        display: "flex",
                        flexDirection: "column",
                        borderTopColor: "#EFEFEF",
                        borderTopWidth: 1,
                        mt: 0.5,
                        mb: 0.5,
                      }}
                    >
                      <H4
                        color="#000"
                        fontSize={14}
                        sx={{
                          width: "100%",
                          textAlign: "center",
                        }}
                        fontWeight={"600"}
                      >
                        {data.closure_date}
                      </H4>
                      <H5
                        sx={{
                          fontFamily: "'Poppins', sans-serif",
                          textAlign: "center",
                        }}
                        color={"#868686"}
                        fontWeight={"400"}
                        fontSize={12}
                      >
                        Close Date
                      </H5>
                    </Grid>
                    <Grid
                      sx={{
                        width: "50%",
                        alignItems: "center",
                        justifyContent: "center",
                        display: "flex",
                        flexDirection: "column",

                        borderLeftWidth: "1px", // set the left border width to 2 pixels
                        borderLeftStyle: "solid", // set the left border style to solid
                        borderLeftColor: "#EFEFEF", // set the left border color
                        pt: 0.5,
                        pb: 0.5,
                      }}
                    >
                      <H4
                        color="#000"
                        sx={{
                          width: "100%",
                          textAlign: "center",
                        }}
                        fontSize={14}
                        fontWeight={"600"}
                      >
                        {data?.min_investment}
                      </H4>
                      <H5
                        sx={{
                          fontFamily: "'Poppins', sans-serif",
                          textAlign: "center",
                        }}
                        fontSize={12}
                        color={"#868686"}
                        fontWeight={"400"}
                      >
                        Min. Investment
                      </H5>
                    </Grid>
                  </Grid>
                </Box>

                <Box
                  sx={{
                    ml: 2,
                    mr: 2,
                    mb: 1,
                    mt: 2,
                    width: "100%",
                    flexDirection: "row",
                    borderRadius: 1,
                    display: { sm: "flex", xs: "none", md: "flex" },
                  }}
                >
                  <Grid
                    onClick={() => {
                      setFundType("ExitLoad");
                    }}
                    sx={{
                      background:
                        fundType === "ExitLoad"
                          ? process.env.REACT_APP_BUTTON_ACTIVE_COLOR
                          : "#FFF",
                      color: fundType === "ExitLoad" ? "#fff" : "#000",
                      cursor: "pointer",
                      borderRadius: 1,
                      p: 1.5,
                    }}
                  >
                    Exit Load
                  </Grid>

                  <Grid
                    onClick={() => {
                      setFundType("Objective");
                    }}
                    sx={{
                      borderRadius: 1,
                      background:
                        fundType === "Objective"
                          ? process.env.REACT_APP_BUTTON_ACTIVE_COLOR
                          : "#FFF",
                      color: fundType === "Objective" ? "#fff" : "#000",
                      cursor: "pointer",
                      p: 1.5,
                    }}
                  >
                    Objective
                  </Grid>
                </Box>
                {fundType === "ExitLoad" && (
                  <Grid
                    sx={{
                      mb: 10,
                      p: 1.7,
                      display: { sm: "flex", xs: "none", md: "flex" },
                    }}
                  >
                    <H4 sx={{ minWidth: "50%" }}>
                      {data?.exit_load_rate
                        ? cleanString(data?.exit_load_rate)
                        : "Nil"}
                    </H4>
                  </Grid>
                )}

                {fundType === "Objective" && (
                  <>
                    <Grid
                      sx={{
                        p: 1.7,
                        cursor: "pointer",
                        display: { sm: "flex", xs: "none", md: "flex" },
                        flexDirection: { sm: "column", md: "column" },
                      }}
                      onClick={() => handleUrlClick(data?.scheme_doc_url)}
                    >
                      <H4 sx={{ minWidth: "50%", mb: 2 }}>
                        {data?.objective ?? ""}
                      </H4>
                      <Divider />
                      <H4 fontWeight={500} fontSize={16} sx={{ mt: 2 }}>
                        VIEW SCHEME DOCUMENTATION
                      </H4>
                    </Grid>
                  </>
                )}
              </Grid>
            </Grid>

            {/* 2nd */}
            <Grid
              xs={12}
              md={6}
              sx={{
                padding: {
                  md: 3,
                  xs: 0,
                  sm: 0,
                },
                pr: {
                  md: 2,
                  xs: 0,
                  sm: 2,
                },
                mt: 1,
              }}
            >
              <Grid
                sx={{
                  background: "#fff",
                  borderRadius: 5,
                  paddingX: {
                    md: 2,
                    xs: 0,
                  },
                  paddingY: {
                    md: 3,
                    xs: 0,
                  },
                }}
              >
                {/* sip/onetime Tab*/}

                <Box sx={sxStyleBox1}>
                  <Button
                    onClick={() => {
                      setSelected(1);
                      setMetalType("Onetime");
                    }}
                    disableElevation
                    disableRipple
                    size="medium"
                    sx={{
                      fontSize: {
                        xs: "12px",
                        sm: "12px",
                        md: "14px",
                      },
                      boxShadow: "0px 4px 4px rgba(239, 239, 239, 1)",
                      textTransform: "none",
                      background:
                        metalType === "Onetime"
                          ? process.env.REACT_APP_PRIMARY_COLOR
                          : "#FFF",
                      color: metalType === "Onetime" ? "#fff" : "#000",
                      width: "50%",
                      borderBottomRightRadius: 0,
                      borderTopRightRadius: 0,
                      borderTopLeftRadius: 10,
                      borderBottomLeftRadius: 0,
                      pt: 1.5,
                      pb: 1.5,
                      "&:hover": {
                        background:
                          metalType === "Onetime"
                            ? process.env.REACT_APP_PRIMARY_COLOR
                            : "#FFF",
                      },
                    }}
                  >
                    One Time
                  </Button>

                  <Button
                    disableElevation
                    disableRipple
                    onClick={() => {
                      setSelected(1);
                      setMetalType("Sip");
                    }}
                    size="medium"
                    sx={{
                      fontSize: {
                        xs: "12px",
                        sm: "12px",
                        md: "14px",
                      },
                      textTransform: "none",
                      pt: 1.5,
                      pb: 1.5,
                      boxShadow: "0px 4px 4px rgba(239, 239, 239, 1)",
                      background:
                        metalType === "Sip"
                          ? process.env.REACT_APP_PRIMARY_COLOR
                          : "#FFF",
                      color: metalType === "Sip" ? "#fff" : "#000",
                      width: "50%",
                      borderTopLeftRadius: 0,
                      borderBottomLeftRadius: 0,
                      borderBottomRightRadius: 0,
                      borderTopRightRadius: 10,
                      "&:hover": {
                        background:
                          metalType === "Sip"
                            ? process.env.REACT_APP_PRIMARY_COLOR
                            : "#FFF",
                      },
                    }}
                  >
                    Start SIP
                  </Button>

                  {metalType === "Onetime" && (
                    <>
                      <Grid
                        sx={{ ml: 2, mt: 2 }}
                        justifyContent="flex-start"
                        alignSelf="flex-start"
                      >
                        <H5 fontWeight={400} color="#838181" fontSize={13}>
                          Minimum Investment Required: ₹{buyMinAmount}
                        </H5>
                      </Grid>

                      <Box sx={sxStyleBox3}>
                        <H5 sx={{ mt: 2 }} fontSize={16}>
                          Investment Amount
                        </H5>
                        <TextField
                          name="onetime"
                          sx={textInputStyles}
                          InputProps={{
                            style: {
                              height: "35px", // change this value to set the desired height
                              width: "100%",
                            },
                          }}
                          onChange={oneTimeChangeHandler}
                          value={investedAmount}
                        />
                      </Box>

                      <Grid justifyContent="center" sx={sxStyleGrid14}>
                        <Grid
                          justifyContent="space-between"
                          alignSelf="center"
                          alignItems="center"
                          sx={{
                            display: "flex",
                            width: {
                              md: "60%",
                              xs: "90%",
                            },
                            mt: 2,
                          }}
                        >
                          {/* first Button */}
                          <Box
                            onClick={() => {
                              setFirstTouchableOpacity(true);
                              setSecondTouchableOpacity(false);
                              setThirdTouchableOpacity(false);
                              setFourthTouchableOpacity(false);
                              setInvestedAmount(
                                Number(buyMinAmount).toString()
                              );
                            }}
                            sx={{
                              background: firstTouchableOpacity
                                ? process.env.REACT_APP_PRIMARY_COLOR
                                : "#FEF7E3",
                              borderRadius: 2,
                              p: 1,
                              pt: 0.4,
                              cursor: "pointer",
                            }}
                          >
                            <Small
                              fontWeight={"700"}
                              sx={{
                                color: firstTouchableOpacity ? "#fff" : "#000",
                              }}
                            >
                              ₹{`${Number(buyMinAmount)}`}
                            </Small>
                          </Box>
                          {/* Second Button */}
                          <Box
                            onClick={() => {
                              setFirstTouchableOpacity(false);
                              setSecondTouchableOpacity(true);
                              setThirdTouchableOpacity(false);
                              setFourthTouchableOpacity(false);
                              setInvestedAmount(
                                (
                                  Number(buyMinAmount) * Number(firstValue)
                                ).toString()
                              );
                            }}
                            sx={{
                              background: secondTouchableOpacity
                                ? process.env.REACT_APP_PRIMARY_COLOR
                                : "#FEF7E3",
                              borderRadius: 2,
                              p: 1,
                              pt: 0.4,
                              cursor: "pointer",
                            }}
                          >
                            <Small
                              fontWeight={"700"}
                              sx={{
                                color: secondTouchableOpacity ? "#fff" : "#000",
                              }}
                            >
                              ₹{`${Number(buyMinAmount) * Number(firstValue)}`}
                            </Small>
                          </Box>
                          {/* Third Button */}
                          <Box
                            onClick={() => {
                              setFirstTouchableOpacity(false);
                              setSecondTouchableOpacity(false);
                              setThirdTouchableOpacity(true);
                              setFourthTouchableOpacity(false);
                              setInvestedAmount(
                                (
                                  Number(buyMinAmount) * Number(secondValue)
                                ).toString()
                              );
                            }}
                            sx={{
                              background: thirdTouchableOpacity
                                ? process.env.REACT_APP_PRIMARY_COLOR
                                : "#FEF7E3",
                              borderRadius: 2,
                              p: 1,
                              pt: 0.4,
                              cursor: "pointer",
                            }}
                          >
                            <Small
                              fontWeight={"700"}
                              sx={{
                                color: thirdTouchableOpacity ? "#fff" : "#000",
                              }}
                            >
                              ₹{`${Number(buyMinAmount) * Number(secondValue)}`}
                            </Small>
                          </Box>
                          {/* Forth Button */}
                          <Box
                            onClick={() => {
                              setFirstTouchableOpacity(false);
                              setSecondTouchableOpacity(false);
                              setThirdTouchableOpacity(false);
                              setFourthTouchableOpacity(true);
                              setInvestedAmount(
                                (
                                  Number(buyMinAmount) * Number(thirdValue)
                                ).toString()
                              );
                            }}
                            sx={{
                              background: fourthTouchableOpacity
                                ? process.env.REACT_APP_PRIMARY_COLOR
                                : "#FEF7E3",
                              borderRadius: 2,
                              p: 1,
                              pt: 0.4,
                              cursor: "pointer",
                            }}
                          >
                            <Small
                              fontWeight={"700"}
                              sx={{
                                color: fourthTouchableOpacity ? "#fff" : "#000",
                              }}
                            >
                              ₹{`${Number(buyMinAmount) * Number(thirdValue)}`}
                            </Small>
                          </Box>
                        </Grid>
                      </Grid>

                      {/* Payment */}
                      <Divider sx={{ mt: 4 }} />
                      <Grid
                        justifyContent="space-between"
                        sx={{
                          display: "flex",
                          flexDirection: {
                            md: "row",
                            xs: "column",
                            sm: "row",
                          },
                          mt: {
                            md: 0,
                            xs: 1,
                            sm: 0,
                          },
                        }}
                      >
                        <Grid
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <H5
                            fontSize={12}
                            fontWeight={"400"}
                            sx={{
                              fontFamily: "'Poppins', sans-serif",
                              color: "#000000",
                              display: "flex",
                              ml: 1,
                            }}
                          >
                            <Box
                              component="img"
                              sx={{
                                height: {
                                  md: 18,
                                  xs: 18,
                                  sm: 18,
                                },
                                minwidth: {
                                  md: 18,
                                  xs: 18,
                                  sm: 18,
                                },
                                mr: 1,
                              }}
                              src="https://acru-asset.s3.us-east-1.amazonaws.com/assets/payment.svg"
                              alt="saas-dasboard-footer"
                            />
                            Payment Method
                          </H5>
                        </Grid>
                        <Grid
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                          }}
                        >
                          <RadioGroup
                            row
                            value={paymentValue}
                            onChange={handleChangePaymentrValue}
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                          >
                            <FormControlLabel
                              value="upi"
                              control={<Radio sx={sxStyleRadio} />}
                              label={<H4 fontSize={12}>UPI</H4>}
                            />
                            <FormControlLabel
                              value="netbanking"
                              control={<Radio sx={sxStyleRadio} />}
                              label={<H4 fontSize={12}>Net Banking</H4>}
                            />
                          </RadioGroup>
                        </Grid>
                      </Grid>
                      <Divider />
                      <Grid textAlign="center">
                        <Button
                          onClick={() => onNextBuyClick()}
                          disableElevation
                          disableRipple
                          size="medium"
                          sx={{
                            background:
                              process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
                            color: "#fff",
                            width: {
                              md: "50%",
                              xs: "90%",
                            },
                            mb: 4,
                            mt: { xs: 3, sm: 6.5, md: 4 },
                            textTransform: "none",
                          }}
                        >
                          Invest
                        </Button>
                      </Grid>
                    </>
                  )}
                  {metalType === "Sip" && (
                    <>
                      <Grid
                        sx={{ ml: 2, mt: 2 }}
                        justifyContent="flex-start"
                        alignSelf="flex-start"
                      >
                        <H5 fontWeight={400} color="#838181" fontSize={13}>
                          Minimum Investment Required: ₹{minSipAmount}
                        </H5>
                      </Grid>

                      <Box sx={sxStyleBox3}>
                        <Box
                          justifyContent="flex-start"
                          alignSelf="flex-start"
                          sx={{
                            width: {
                              xs: "100%",
                              sm: "100%",
                              md: "100%",
                            },
                          }}
                        >
                          <H5 sx={{ mt: 2 }} fontSize={16}>
                            Enter SIP Amount
                          </H5>

                          <TextField
                            name="sip"
                            sx={textInputStyles}
                            InputProps={{
                              style: {
                                height: "35px", // change this value to set the desired height
                                width: "100%",
                              },
                            }}
                            onChange={sipChangeHandler}
                            value={investedSipAmount}
                          />
                        </Box>
                      </Box>

                      <Grid justifyContent="center" sx={sxStyleGrid14}>
                        <Grid
                          justifyContent="space-between"
                          alignSelf="center"
                          alignItems="center"
                          sx={{
                            display: "flex",
                            width: {
                              md: "60%",
                              xs: "90%",
                            },
                            mt: 2,
                          }}
                        >
                          {/* first Button */}
                          <Box
                            onClick={() => {
                              setFirstTouchableOpacity(true);
                              setSecondTouchableOpacity(false);
                              setThirdTouchableOpacity(false);
                              setFourthTouchableOpacity(false);
                              setInvestedSipAmount(
                                Number(minSipAmount).toString()
                              );
                            }}
                            sx={{
                              background: firstTouchableOpacity
                                ? process.env.REACT_APP_PRIMARY_COLOR
                                : "#FEF7E3",
                              borderRadius: 2,
                              p: 1,
                              pt: 0.4,
                              cursor: "pointer",
                            }}
                          >
                            <Small
                              fontWeight={"700"}
                              sx={{
                                color: firstTouchableOpacity ? "#fff" : "#000",
                              }}
                            >
                              ₹{`${Number(minSipAmount)}`}
                            </Small>
                          </Box>
                          {/* Second Button */}
                          <Box
                            onClick={() => {
                              setFirstTouchableOpacity(false);
                              setSecondTouchableOpacity(true);
                              setThirdTouchableOpacity(false);
                              setFourthTouchableOpacity(false);
                              setInvestedSipAmount(
                                (
                                  Number(minSipAmount) * Number(firstValue)
                                ).toString()
                              );
                            }}
                            sx={{
                              background: secondTouchableOpacity
                                ? process.env.REACT_APP_PRIMARY_COLOR
                                : "#FEF7E3",
                              borderRadius: 2,
                              p: 1,
                              pt: 0.4,
                              cursor: "pointer",
                            }}
                          >
                            <Small
                              fontWeight={"700"}
                              sx={{
                                color: secondTouchableOpacity ? "#fff" : "#000",
                              }}
                            >
                              ₹{`${Number(minSipAmount) * Number(firstValue)}`}
                            </Small>
                          </Box>
                          {/* Third Button */}
                          <Box
                            onClick={() => {
                              setFirstTouchableOpacity(false);
                              setSecondTouchableOpacity(false);
                              setThirdTouchableOpacity(true);
                              setFourthTouchableOpacity(false);
                              setInvestedSipAmount(
                                (
                                  Number(minSipAmount) * Number(secondValue)
                                ).toString()
                              );
                            }}
                            sx={{
                              background: thirdTouchableOpacity
                                ? process.env.REACT_APP_PRIMARY_COLOR
                                : "#FEF7E3",
                              borderRadius: 2,
                              p: 1,
                              pt: 0.4,
                              cursor: "pointer",
                            }}
                          >
                            <Small
                              fontWeight={"700"}
                              sx={{
                                color: thirdTouchableOpacity ? "#fff" : "#000",
                              }}
                            >
                              ₹{`${Number(minSipAmount) * Number(secondValue)}`}
                            </Small>
                          </Box>
                          {/* Forth Button */}
                          <Box
                            onClick={() => {
                              setFirstTouchableOpacity(false);
                              setSecondTouchableOpacity(false);
                              setThirdTouchableOpacity(false);
                              setFourthTouchableOpacity(true);
                              setInvestedSipAmount(
                                (
                                  Number(minSipAmount) * Number(thirdValue)
                                ).toString()
                              );
                            }}
                            sx={{
                              background: fourthTouchableOpacity
                                ? process.env.REACT_APP_PRIMARY_COLOR
                                : "#FEF7E3",
                              borderRadius: 2,
                              p: 1,
                              pt: 0.4,
                              cursor: "pointer",
                            }}
                          >
                            <Small
                              fontWeight={"700"}
                              sx={{
                                color: fourthTouchableOpacity ? "#fff" : "#000",
                              }}
                            >
                              ₹{`${Number(minSipAmount) * Number(thirdValue)}`}
                            </Small>
                          </Box>
                        </Grid>
                      </Grid>
                      {/* date */}
                      <Divider sx={{ mt: 4 }} />
                      <Grid
                        justifyContent="space-between"
                        sx={{ p: 1.5, display: "flex" }}
                      >
                        <Grid
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <H5
                            fontSize={12}
                            fontWeight={"400"}
                            sx={{
                              fontFamily: "'Poppins', sans-serif",
                              color: "#000000",
                              display: "flex",
                            }}
                          >
                            <Box
                              component="img"
                              sx={{
                                height: 15,
                                minwidth: {
                                  md: 15,
                                  xs: 10,
                                  sm: 10,
                                },
                                mr: 1,
                              }}
                              src="https://acru-asset.s3.us-east-1.amazonaws.com/assets/calender.svg"
                              alt="saas-dasboard-footer"
                            />
                            SIP Date
                          </H5>
                        </Grid>
                        <Grid
                          onClick={() => handlesipOpenModal()}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                          }}
                        >
                          <H5
                            fontSize={12}
                            fontWeight={"400"}
                            sx={{
                              fontFamily: "'Poppins', sans-serif",
                              color: "#000000",
                              flexDirection: "row",
                              marginRight: 1,
                            }}
                          >
                            {` ${
                              selectedDate == ""
                                ? "Select installment date"
                                : `${dateOrdinal(selectedDate)} of every month`
                            } `}
                          </H5>
                          <Box
                            component="img"
                            src="https://acru-asset.s3.us-east-1.amazonaws.com/assets/dropDown.svg"
                            sx={sxStyleDropDown}
                          />
                        </Grid>
                      </Grid>
                      <Divider />

                      <Grid textAlign="center">
                        <Button
                          onClick={() => onNextSIPClick()}
                          disableElevation
                          disableRipple
                          size="medium"
                          sx={{
                            background:
                              process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
                            color: "#fff",
                            width: {
                              md: "50%",
                              xs: "90%",
                            },
                            mb: 4,
                            mt: { xs: 3, sm: 6.5, md: 4 },
                            textTransform: "none",
                          }}
                        >
                          Start SIP
                        </Button>
                      </Grid>
                    </>
                  )}
                </Box>
              </Grid>
            </Grid>
          </Grid>
          <Box
            sx={{
              ml: 2,
              mr: 2,
              mb: 1,
              mt: 2,
              width: "100%",
              flexDirection: "row",
              borderRadius: 1,
              display: { sm: "none", xs: "flex", md: "none" },
            }}
          >
            <Grid
              onClick={() => {
                setFundType("ExitLoad");
              }}
              sx={{
                background:
                  fundType === "ExitLoad"
                    ? process.env.REACT_APP_BUTTON_ACTIVE_COLOR
                    : "#FFF",
                color: fundType === "ExitLoad" ? "#fff" : "#000",
                cursor: "pointer",
                borderRadius: 1,
                p: 1.5,
              }}
            >
              Exit Load
            </Grid>

            <Grid
              onClick={() => {
                setFundType("Objective");
              }}
              sx={{
                borderRadius: 1,
                background:
                  fundType === "Objective"
                    ? process.env.REACT_APP_BUTTON_ACTIVE_COLOR
                    : "#FFF",
                color: fundType === "Objective" ? "#fff" : "#000",
                cursor: "pointer",
                p: 1.5,
              }}
            >
              Objective
            </Grid>
          </Box>
          {fundType === "ExitLoad" && (
            <Grid
              sx={{
                p: 1.7,
                display: { sm: "none", xs: "flex", md: "none" },
              }}
            >
              <H4 sx={{ minWidth: "50%" }}>
                {data?.exit_load_rate
                  ? cleanString(data?.exit_load_rate)
                  : "Nil"}
              </H4>
            </Grid>
          )}

          {fundType === "Objective" && (
            <>
              <Grid
                sx={{
                  p: 1.7,
                  cursor: "pointer",
                  display: { sm: "none", xs: "flex", md: "none" },
                  flexDirection: { xs: "column" },
                }}
                onClick={() => handleUrlClick(data?.scheme_doc_url)}
              >
                <H4 sx={{ minWidth: "50%", mb: 2 }}>{data?.objective ?? ""}</H4>
                <Divider />
                <H4 fontWeight={500} fontSize={16} sx={{ mt: 2 }}>
                  VIEW SCHEME DOCUMENTATION
                </H4>
              </Grid>
            </>
          )}
        </>
      </Grid>
    </>
  );
}

const text = {
  fontFamily: "'Poppins', sans-serif",
  display: "flex",
  fontSize: 15,
  mt: 0.13,
};
const sxStylebutton = {
  background: "#F6F6F6",
  pl: {
    md: 4,
    xs: 2,
    sm: 2,
  },
  pr: {
    md: 4,
    xs: 2,
    sm: 2,
  },
  pt: 0,
  height: { sm: "100vh", md: "90vh" },
};
const sxStyleRadio = {
  color: "#FFF5D1",
  "&.Mui-checked": {
    color: process.env.REACT_APP_BUTTON_ACTIVE_COLOR,
  },
};
const sxStyleImage = {
  height: {
    xs: 30,
    sm: 30,
    md: 50,
  },
  minwidth: {
    xs: 30,
    sm: 30,
    md: 30,
  },
  m: 0.6,
  mb: 0,
};
const sxStyleDropDown = {
  height: {
    xs: 6,
    sm: 6,
    md: 6,
  },
  minwidth: {
    xs: 6,
    sm: 6,
    md: 6,
  },
};

const sxStyleDotStyle = {
  background: "#D9D9D9",
  width: {
    xs: 8,
    sm: 8,
    md: 10,
  },
  height: {
    xs: 8,
    sm: 8,
    md: 10,
  },
  borderRadius: {
    xs: 40,
    sm: 40,
    md: 20,
  },
  mr: 1,
  mt: 0.5,
};
const sxStyleBox1 = {
  borderRadius: 4,
  ml: { xs: 1, sm: 1, md: 2 },
  mr: { xs: 1, sm: 1, md: 2 },
  mt: { xs: 1, sm: 1, md: 0 },
  boxShadow: {
    xs: 0,
    sm: "0px 4px 10px rgba(239, 239, 239, 1)",
    md: "0px 4px 10px rgba(239, 239, 239, 1)",
  },
};

const sxStyleGrid14 = {
  mb: 2,
  width: "100%",
  display: "flex",
};

const textInputStyles = {
  width: "100%",
  marginTop: {
    xs: 0.5,
    sm: 2,
    md: 0.5,
  },
  padding: 0.1,
};
const sxStyleBox3 = {
  paddingX: 2,
  paddingY: 0.5,
  pb: 2,
};
